<template>
    <div id="notifications">
        <div v-for="error in decodedErrors" v-if="displayErrors">

          <div class="alert alert-danger" role="alert">
              <strong v-if="error.label">{{error.label}}: </strong>
              <button class="closed" data-dismiss="alert">
                <!-- <i class="fa fa-times"></i> -->
              </button>
              <ul>
                <li v-for="(em, idx) in error.message" :keys="'error-message-' + idx ">{{em}}</li>
              </ul>
          </div>

<!--
            <div class="alert alert-danger" v-if="error.required" role="alert">
                <button class="close" data-dismiss="alert"></button>
                <strong>{{error.label}}: {{error.message}}</strong> champ requis

            </div>

            <div class="alert alert-danger" v-if="error.invalid" role="alert">
              <button class="close" data-dismiss="alert"></button>
              <strong>{{error.label}}: </strong> champ non valide

            </div>

            <div class="alert alert-danger" v-if="error.hasOwnProperty('incompatible') && error.incompatible" role="alert">
                <button class="close" data-dismiss="alert"></button>
                <strong>{{error.label}}: </strong> champs incompatible (les dates se chevauchent)

            </div> -->


        </div>
    </div>
</template>

<script>
    export default {
        props: ["error", "fields", "model"],

        computed: {

            errorList () {
                return this.error.errors
            },

            message () {
                return this.error.message
            },

            decodedErrors () {
                const vm = this
                return _.chain(vm.errorList).map((errors, modelPath) => {
                    if (modelPath === 'date_incompatibility')
                        return {
                            label: "Dates",
                            invalid: false,
                            required: false,
                            incompatible: true,
                        }

                    const field = _.find(vm.fields, (f) => f.model === modelPath)
                    if (field)
                    {
                      // console.warn(String(errors) + " " + field.label)
                      var error_obj = {
                      label:field.label,
                      message:errors,
                      }
                      return (error_obj)
                    }
                    return null
                    // return (field) ?
                    //     _.reduce(
                    //         errors,
                    //         (result, error) => {
                    //           // debugger
                    //           // result
                    //            _.assign({}, result, {
                    //             label: field.label,
                    //             required: field.required || /required/.test(error),
                    //             invalid: field.invalid || /valid/.test(error) || /must be/.test(error)
                    //         })
                    //       }
                    //         ,
                    //         {
                    //             required: false,
                    //             label: "",
                    //             invalid: false
                    //         }
                    //     ) : null
                }).filter(f => !_.isNull(f)).value()
            },

            displayErrors () {
                return this.decodedErrors.length
            }

        },
    }
</script>
<style scoped>
.closed {
  background-position: -95px -10px !important;
  background: url(/static/media/noti-cross.8b70ae64.png) no-repeat scroll 0 0 transparent;
  float: right;
  width: 10px;
  height: 15px;
  opacity: 0.8;
  border: none;
}
</style>



// WEBPACK FOOTER //
// client/components/Form/Notifications.vue